var CHAR_CODES;
(function (CHAR_CODES) {
    CHAR_CODES[CHAR_CODES["ENTER"] = 13] = "ENTER";
    CHAR_CODES[CHAR_CODES["SPACE"] = 32] = "SPACE";
})(CHAR_CODES || (CHAR_CODES = {}));
const handleKeyDown = (keyCode, handler) => (event) => {
    if (event.keyCode === keyCode) {
        event.preventDefault();
        handler();
    }
};
export const handleSpaceKeyDown = (handler) => (event) => handleKeyDown(CHAR_CODES.SPACE, handler)(event);
export const handleKeyPressEnterOrSpace = (handler) => (event) => {
    if (event.key === ' ' || event.key === 'Enter') {
        handler(event);
    }
};
export const focusElement = ({ selector, canFocus = false, preventScroll = false }) => {
    const element = document.querySelector(selector);
    if (element) {
        !canFocus && element.setAttribute('tabindex', '-1');
        element.focus({ preventScroll });
    }
};
export const scrollElementIntoView = (selector, scrollOptions = {}) => {
    var _a;
    (_a = document.querySelector(selector)) === null || _a === void 0 ? void 0 : _a.scrollIntoView(scrollOptions);
};
export const addCircularTabFocus = (firstElementSelector, lastElementSelector) => {
    const first = document.querySelector(firstElementSelector);
    const last = document.querySelector(lastElementSelector);
    if (first && last) {
        first.addEventListener('keydown', (event) => {
            if (event.keyCode === 9 && event.shiftKey) {
                event.preventDefault();
                last.focus();
            }
        });
        last.addEventListener('keydown', (event) => {
            if (event.keyCode === 9 && !event.shiftKey) {
                event.preventDefault();
                first.focus();
            }
        });
    }
};
export const hookToAttributeSelector = (hook, hookKey = 'data-hook') => `[${hookKey}="${hook}"]`;
//# sourceMappingURL=helpers.js.map